import { Accessor } from "solid-js";

export class K12GradReqOverviewDetailHeaderContext
{
    status: Accessor<string>;
    constructor(status: Accessor<string>) {
        this.status = status;
    }
}
